import { Injectable } from '@angular/core';
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";

@Injectable({
  providedIn: 'root'
})
export class LaService { // Loading Analysis Service

  constructor() { }

  setLARunning(isRunning: boolean) {
    localStorage.setItem("isLARunning", "" + isRunning);
  }

  isLARunning() {
    let isLARunning: boolean = false;

    const isLARunningStr: string = localStorage.getItem("isLARunning");
    if (isNotNullOrUndefined(isLARunningStr)) {
      if (isLARunningStr == "true") {
        isLARunning = true;
      }
    }

    return isLARunning;
  }

  setLADataAvailable(areLaDataAvailable: boolean) {
    localStorage.setItem("areLADataAvailable", "" + areLaDataAvailable);
  }

  setLADataAvailableGP(areLaDataAvailable: boolean) {
    localStorage.setItem("areLADataAvailable", "" + areLaDataAvailable);
  }

  areLADataAvailable() {
    let areLaDataAvailable: boolean = false;

    const areLaDataAvailableStr: string = localStorage.getItem("areLADataAvailable");
    if (isNotNullOrUndefined(areLaDataAvailableStr)) {
      if (areLaDataAvailableStr == "true") {
        areLaDataAvailable = true;
      }
    }
    return areLaDataAvailable;
  }

  areLADataAvailableGP() {
    let areLaDataAvailable: boolean = false;

    const areLaDataAvailableStr: string = localStorage.getItem("areLADataAvailableGP");
    if (isNotNullOrUndefined(areLaDataAvailableStr)) {
      if (areLaDataAvailableStr == "true") {
        areLaDataAvailable = true;
      }
    }
    return areLaDataAvailable;
  }
}
